import React from 'react';

export default function Loader({ size }) {
  return <div className="loader" style={{ width: size, height: size }}></div>;
}
